<template>
  <div
    v-if="pages > 1"
    class="table-pagination"
  >
    <div
      v-for="page in showedPages"
      :key="page"
      :class="['table-pagination__element', {'selected': page === currentPage}]"
      @click="$emit('change-page', page)"
    >
      {{ page }}
    </div>
  </div>
</template>

<script>
/**
 * компонент пагинации таблицы
 * @module Shared/Component/Table/Pagination
 * @vue-prop {Number} currentPage - текущая страницы
 * @vue-prop {Number} pages - общее количество страниц
 * @vue-computed {Array} showedPages - страницы которые необходимо показать
 * */

export default {
  name: 'TablePagination',
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    pages: {
      type: Number,
      default: 0
    }
  },
  computed: {
    showedPages() {
      return Array.from({ length: this.pages }, (_, i) => i + 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.table-pagination {
  display: flex;

  &__element {
    width: 24px;
    height: 24px;
    margin-right: 5px;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
  }

  &__element:last-child {
    margin-right: 0px;
  }

  &__element.selected {
    background-color: rgba(140, 140, 140, 0.3);
    border-radius: 24px;

    cursor: default;
  }
}
</style>
